import { get } from "lodash";
import { PLAN_ROWS } from "./formula-plan-rows";
import { MetricsKind } from "../types";
import { referenceMetricValueOrCompute, sumColumnValues } from "../sibling-value-getter/getter";
import { safeParseFloat } from "lib/number";
import { BULK_IDENTIFIER } from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";

export const BREADTH_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    if (factoryOptions.useSize || get(getterParams, "node.data.type") === BULK_IDENTIFIER) {
        return undefined;
    }

    const planRowColumnValuesSum = sumColumnValues(MetricsKind.PLAN_ROWS, factoryOptions, getterParams);
    const currentPlanRowValue = referenceMetricValueOrCompute(
        () => safeParseFloat(PLAN_ROWS({ factoryOptions, getterParams }), 0),
        getterParams,
        MetricsKind.PLAN_ROWS
    );

    if (planRowColumnValuesSum > 0) {
        return (currentPlanRowValue / planRowColumnValuesSum) * 100;
    }

    return 0;
};
